// NOTE: JS `toFixed` sets number of decimal places but does rounding without our control (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toFixed#using_tofixed)
// Use this method to control the direction of rounding to always round DOWN
// Doesn't support negative number formatting yet

/**
 *
 * Eg. toFixedRoundedDown(0.002345, 4) === 0.0023
 * - calculate these veriables
 *   - currentDigitsAfterDecimalPoint is 6
 *   - currentDigitsBeforeDecimalPoint is 1
 *   - expectedDigitsAfterDecimalPoint is 4
 * - strip digits after decimal point: result.slice(0, 1+1+4)
 *
 * Eg. toFixedRoundedDown(0.12, 4) === 0.1200
 * - calculate these veriables
 *   - currentDigitsAfterDecimalPoint is 2
 *   - currentDigitsBeforeDecimalPoint is 1
 *   - expectedDigitsAfterDecimalPoint is 4
 * - pad digits after decimal point: result += '00'
 *
 * Eg. toFixedRoundedDown(12345, -2) === 12300
 * - calculate these veriables
 *   - currentDigitsAfterDecimalPoint is 0
 *   - currentDigitsBeforeDecimalPoint is 5
 *   - expectedDigitsAfterDecimalPoint is 0
 * - set digits to zeros: '123' + '00' = '12300'
 */
export function toFixedRoundedDown(number, digits) {
  // Do not support negative number yet
  if (number < 0) {
    return number.toString();
  }
  let result = number.toString();
  const idxOfDecimalPoint = [...result].indexOf('.');
  const currentDigitsAfterDecimalPoint = idxOfDecimalPoint > -1 ? result.length - idxOfDecimalPoint - 1 : 0;
  const currentDigitsBeforeDecimalPoint = idxOfDecimalPoint > -1 ? idxOfDecimalPoint : result.length;

  // pad zeros after the decimal point if necessary
  // e.g. fn(123.4, 2) === 123.40
  const expectedDigitsAfterDecimalPoint = Math.max(0, digits);
  if (currentDigitsAfterDecimalPoint < expectedDigitsAfterDecimalPoint) {
    const paddedZeros = Array.from({
      length: expectedDigitsAfterDecimalPoint - currentDigitsAfterDecimalPoint
    }).fill('0').join('');
    if (idxOfDecimalPoint > -1) {
      result += paddedZeros;
    } else {
      result += `.${paddedZeros}`;
    }
  }

  // strip digits after decimal point if necessary
  // e.g. fn(123.456, 2) === 123.45
  if (digits >= 0 && currentDigitsAfterDecimalPoint > expectedDigitsAfterDecimalPoint) {
    result = result.slice(0, currentDigitsBeforeDecimalPoint + (expectedDigitsAfterDecimalPoint > 0 ? 1 : 0) + expectedDigitsAfterDecimalPoint);
  }

  // set digits to zero to reduce precision before decimal point if necessary
  // e.g. fn(12345, -2) === 12300
  if (digits < 0 && currentDigitsBeforeDecimalPoint + digits > 0) {
    result = result.slice(0, currentDigitsBeforeDecimalPoint + digits);
    const paddedZeros = Array.from({
      length: -digits
    }).fill('0').join('');
    result += paddedZeros;
  }
  return result;
}